/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { observer } from 'mobx-react';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Switch from '@material-ui/core/Switch';

import styles from './ElectroSwitch.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

type TypeProps = {|
  field: Object,
  onChange: Function,
  group?: boolean,
|};

function ElectroSwitch(props: TypeProps): React.Element<*> {
  const { field, group, onChange }: TypeProps = props;

  const isSwitchDisabled: Function = (fieldItem: any) =>
    Object.values(fieldItem.value).includes(false);

  const customLabel: Function = (fieldItem: any) => (
    <React.Fragment>
      <span>{fieldItem.label}</span>
      <FormHelperText>{fieldItem.extra.helperText}</FormHelperText>
    </React.Fragment>
  );

  const formControlLabelProps: Function = (fieldItem: any) => {
    return {
      className: styles['form-control-label'],
      labelPlacement: 'start',
      label:
        fieldItem.extra && fieldItem.extra.helperText ? customLabel(fieldItem) : fieldItem.label,
      control: React.createElement(Switch, {
        checked: fieldItem.value,
        onChange: () => {
          fieldItem.set(!fieldItem.value);
          if (onChange) onChange();
        },
        value: fieldItem.value.toString(),
        color: 'primary',
      }),
    };
  };

  return (
    <div className={`${styles['electro-switch']}`}>
      <FormControl>
        <FormGroup>
          <React.Fragment>
            {group === true ? (
              field.map((item: Object, index: number) => {
                return <FormControlLabel key={index.toString()} {...formControlLabelProps(item)} />;
              })
            ) : (
              <FormControlLabel {...formControlLabelProps(field)} />
            )}
          </React.Fragment>
        </FormGroup>
        {field.extra && field.extra.helperText && (
          <FormHelperText error={isSwitchDisabled(field)}>{field.extra.helperText}</FormHelperText>
        )}
      </FormControl>
    </div>
  );
}

export default observer(ElectroSwitch);
